import { render, staticRenderFns } from "./Movements.vue?vue&type=template&id=59a36dca&scoped=true"
import script from "./Movements.vue?vue&type=script&lang=js"
export * from "./Movements.vue?vue&type=script&lang=js"
import style0 from "./Movements.vue?vue&type=style&index=0&id=59a36dca&prod&scoped=true&lang=css"
import style1 from "./Movements.vue?vue&type=style&index=1&id=59a36dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a36dca",
  null
  
)

export default component.exports